import Input from '@superfunnel/ui-core/v2/Input';
import Label from '@superfunnel/ui-core/v2/Label';
import { classNames } from '@superfunnel/utils';
import { useMemo } from 'react';
import SettingsHelpTooltip from './SettingsHelpTooltip';

interface ISettingsTextField {
  title?: string;
  helpText?: string;
  value?: string;
  setValue?: any;
  pattern?: string;
  placeholder?: string;
  prefix?: string;
  className?: string;
}

export const SettingsTextField = ({
  title,
  helpText,
  value,
  setValue,
  pattern,
  className,
  prefix = '',
  placeholder = '',
}: ISettingsTextField) => {
  const isValid = useMemo(() => {
    if (pattern && value) {
      return new RegExp(pattern).test(value);
    }
    return true;
  }, [value, pattern]);

  return (
    <>
      <div
        className={classNames(
          'font-inter grid w-full items-center gap-1',
          className,
        )}
      >
        <Label
          htmlFor="email"
          className="text-base-700 flex items-center gap-2 text-sm font-medium"
        >
          {title}{' '}
          {helpText && <SettingsHelpTooltip text={helpText} iconSize="sm" />}
        </Label>
        <div className="grid grid-cols-1 gap-2">
          <Input
            className={`h-10 ${prefix ? 'rounded-r-2lg' : 'rounded-2lg'}`}
            key={'edit-name'}
            value={value}
            prefix={prefix}
            onChange={(v) => setValue(v.target.value)}
            validation={
              isValid ? undefined : { status: 'error', message: 'Invalid' }
            }
            placeholder={placeholder}
          />
        </div>
      </div>
    </>
  );
};
